import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { useReactFlow } from '@xyflow/react';

export function WATCHER__xyflow_node_focus() {
  const { getNode, setCenter, getZoom } = useReactFlow();

  const { g_graph__node_id_selected } = use_slice_ui(['g_graph__node_id_selected']);

  /*
   * EFFECT: Focus & Center on Selected Node without changing zoom
   */
  use_effect(() => {
    let node_id = g_graph__node_id_selected;

    if (node_id === ENUM__string_id_empty.UUID) return;

    const timeoutId = setTimeout(() => {
      if (node_id === ENUM__string_id_empty.UUID) return;

      const node = getNode(node_id);
      if (!node) return;

      // Extract node dimensions and position
      const x = node.position.x + (node.measured?.width ?? 0) / 2;
      const y = node.position.y + (node.measured?.height ?? 0) / 2;
      const zoom = getZoom();

      setCenter(x, y, {
        zoom, // Keeps the exact zoom level the user is currently on
        duration: 400, // Smooth animation in ms
      });
    }, 50);

    return () => clearTimeout(timeoutId);
  }, [g_graph__node_id_selected, getNode, setCenter, getZoom]);

  return null;
}
